import * as types from '../mutationsTypes/MutationsTypes'

const state = {
  projects: [
    {
      'key': 0,
      'id': 'domingo',
      'link': 'https://domingo.tv',
      'thumbnail': 'static/img/projects/domingo.jpg',
      'title': 'DominGo',
      'shortTitle': 'DominGo',
      'client': 'Streamer - Youtuber',
      'type': 'Freelance Project',
      'role': 'Project Manager / UI-UX Designer / Developer',
      'stack': 'React / Redux / KoaJS / Node',
      'more': ['audience', '+1.200M monthly viewed pages']
    },
    {
      'key': 1,
      'id': 'voices',
      'link': 'https://voices.gg',
      'thumbnail': 'static/img/projects/voices.jpg',
      'title': 'Voices',
      'shortTitle': 'Voices',
      'client': 'Game web app',
      'type': 'Freelance Project',
      'role': 'Project Manager / UI-UX Designer',
      'stack': 'VueJS / VueX / Node / Sockets',
      'more': ['audience', '+1.000M viewed pages first month']
    },
    {
      'key': 2,
      'id': 'lifeRide',
      'link': 'https://www.liferidebyhotelf1.com/',
      'thumbnail': 'static/img/projects/life-ride.jpg',
      'title': 'Life Ride',
      'shortTitle': 'Life Ride',
      'client': 'Hotel F1',
      'type': 'Internship',
      'role': 'Front-End Developer',
      'stack': 'ES6 / Canvas',
      'more': ['agency', 'anonymous']
    },
    {
      'key': 3,
      'id': 'gotaga',
      'link': 'http://gotaga.tv',
      'thumbnail': 'static/img/projects/gotaga.jpg',
      'title': 'Gotaga',
      'shortTitle': 'Gotaga',
      'client': 'Streamer - Youtuber',
      'type': 'Freelance project',
      'role': 'Full-Stack Developer / UI-UX Designer',
      'stack': 'AngularJS / Wordpress / WP Rest API',
      'more': ['audience', '+700k monthly viewed pages']
    },
    {
      'key': 4,
      'id': 'zerator',
      'link': 'http://zerator.com',
      'thumbnail': 'static/img/projects/zerator.jpg',
      'title': 'Zerator',
      'shortTitle': 'Zerator',
      'client': 'Streamer - Youtuber',
      'type': 'Freelance project',
      'role': 'Full-Stack Developer / UI-UX Designer',
      'stack': 'AngularJS / Wordpress / WP Rest API',
      'more': ['audience', '+600k monthly viewed pages']
    },
    {
      'key': 5,
      'id': 'serreChevalier',
      'link': 'http://www.serre-chevalier.com/',
      'thumbnail': 'static/img/projects/serre-chevalier.jpg',
      'title': 'Serre-Chevalier',
      'shortTitle': 'Serre-Che',
      'client': 'Tourist Office / Ski station',
      'type': 'Freelance project',
      'role': 'Lead Front-End Developer',
      'stack': 'Wordpress / SITRA2 API / Custom plugins',
      'more': ['agency', 'mezcalito']
    }
  ],
  currentIndex: 0,
  nextIndex: null,
  prevIndex: null,
  toggleHover: false,
  direction: null,
  requestNextSlide: null
}

const mutations = {
  [types.SET_INDEX]: (state, index) => {
    state.currentIndex = index
  },
  [types.SET_NEXT_INDEX]: (state, nextIndex) => {
    state.nextIndex = nextIndex
  },
  [types.SET_PREV_INDEX]: (state, prevIndex) => {
    state.prevIndex = prevIndex
  },
  [types.SET_TOGGLE_HOVER]: (state, toggleHover) => {
    state.toggleHover = toggleHover
  },
  [types.SET_DIRECTION]: (state, direction) => {
    state.direction = direction
  },
  [types.SET_REQUEST_NEXT_SLIDE]: (state, value) => {
    state.requestNextSlide = value
  }
}

const getters = {
  projects: state => state.projects,
  currentIndex: state => state.currentIndex,
  nextIndex: state => state.nextIndex,
  prevIndex: state => state.prevIndex,
  toggleHover: state => state.toggleHover,
  direction: state => state.direction,
  requestNextSlide: state => state.requestNextSlide
}

const actions = {
  setCurrentIndex ({commit}, index) {
    if (index > state.projects.length - 1) {
      index = 0
    } else if (index < 0) {
      index = state.projects.length - 1
    }
    commit([types.SET_INDEX], index)
  },
  setNextIndex ({commit}, nextIndex) {
    if (nextIndex > state.projects.length - 1) {
      nextIndex = 0
    }

    commit([types.SET_NEXT_INDEX], nextIndex)
  },
  setPrevIndex ({commit}, prevIndex) {
    if (prevIndex < 0) {
      prevIndex = state.projects.length - 1
    }

    commit([types.SET_PREV_INDEX], prevIndex)
  },
  setToggleHover ({commit}, toggleHover) {
    commit([types.SET_TOGGLE_HOVER], toggleHover)
  },
  setDirection ({commit}, direction) {
    commit([types.SET_DIRECTION], direction)
  },
  setRequestNextSlide ({commit}, value) {
    commit([types.SET_REQUEST_NEXT_SLIDE], value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/Slider.js